import { ColumnViewModel } from '../../shared/column-types';

export const GENES_VDA_SUMMARY: ColumnViewModel = {
  columns: [
    'geneSymbol',
    'variantStrID',
    'diseaseName',
    'diseaseUMLSCUI',
    'geneNcbiIDs',
    'numDiseasesAssociatedToVariant',
    'score',
    'sourceScore',
    'mostSevereConsequences',
    'numPMIDsupportingAssociation',
    'numberChemsIncludedInEvidence',
    'numberPmidsWithChemsIncludedInEvidence',
    'yearInitial',
    'yearFinal',
    'EI',
    'variantDSI',
    'variantDPI',
    'chromosome',
    'coord',
    'alleles',
    'alleleFreqExome',
    'alleleFreqGenome',
    'DBSNPclass',
    'polyphen_score',
    'sift_score',
    'diseaseType',
    'diseaseClassName_MSH',
    'diseaseClassName_UMLS',
    'diseaseClassName_DO',
    'diseaseClassName_HPO',
    'disease_prevalence_class',
    'disease_prevalence_type',
    'disease_prevalence_geo_area',
    'disease_inheritance',
  ],
  defaultVisible: [
    'geneSymbol',
    'variantStrID',
    'diseaseName',
    'numDiseasesAssociatedToVariant',
    'score',
    'sourceScore',
    'mostSevereConsequences',
    'numPMIDsupportingAssociation',
    'yearInitial',
    'yearFinal',
    'EI',
    'variantDSI',
    'variantDPI',
    'chromosome',
    'coord',
  ],
};